module.exports = __webpack_public_path__ + "static/media/only-memory.a30bd350.svg";